/** Shared modal scrim + centered card (click-scrim-to-close). */
import React from 'react';
import { Modal, Platform, Pressable, Text, View } from 'react-native';
import { useTheme } from '../../context/themeContext';
import SkIcon from '../skIcon';

interface Props {
  visible: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  width?: number;
  children: React.ReactNode;
  footer?: React.ReactNode;
  headerTone?: 'default' | 'accent' | 'danger';
  /** Tighter paddings for dense, compact forms. Default keeps the roomy layout. */
  compact?: boolean;
}

const ModalShell: React.FC<Props> = ({ visible, onClose, title, subtitle, width = 560, children, footer, headerTone = 'default', compact = false }) => {
  const { theme } = useTheme();
  const { colors, font } = theme;
  const headBg = headerTone === 'danger' ? colors.dangerSoft : headerTone === 'accent' ? colors.accentSoft : colors.card;
  const headColor = headerTone === 'danger' ? colors.danger : headerTone === 'accent' ? colors.accentInk : colors.ink;
  const headPad = compact ? 16 : 20;
  const bodyPad = compact ? 16 : 20;
  const footPad = compact ? 12 : 16;

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <Pressable onPress={onClose} style={{ flex: 1, backgroundColor: 'rgba(16,24,40,0.5)', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <Pressable onPress={() => {}} style={{ width: '100%', maxWidth: width, backgroundColor: colors.card, borderWidth: 1, borderColor: colors.line, borderRadius: 12, overflow: 'hidden', ...(Platform.OS === 'web' ? ({ boxShadow: '0 16px 48px rgba(16,24,40,.25)' } as any) : {}) }}>
          <View style={{ flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', paddingHorizontal: headPad, paddingVertical: compact ? 14 : 20, backgroundColor: headBg, borderBottomWidth: 1, borderColor: colors.line }}>
            <View style={{ flex: 1 }}>
              <Text style={{ fontFamily: font.sansSemibold, fontSize: compact ? 15 : 16, fontWeight: '600', color: headColor }}>{title}</Text>
              {subtitle ? <Text style={{ fontFamily: font.sans, fontSize: 12, color: headerTone === 'danger' ? colors.danger : colors.ink3, marginTop: 3 }}>{subtitle}</Text> : null}
            </View>
            <Pressable onPress={onClose} style={{ width: 28, height: 28, alignItems: 'center', justifyContent: 'center' }}>
              <SkIcon name="x" size={16} color={colors.ink3} />
            </Pressable>
          </View>
          <View style={{ padding: bodyPad }}>{children}</View>
          {footer ? <View style={{ flexDirection: 'row', justifyContent: 'flex-end', gap: 10, padding: footPad, borderTopWidth: 1, borderColor: colors.line, backgroundColor: colors.paper2 }}>{footer}</View> : null}
        </Pressable>
      </Pressable>
    </Modal>
  );
};

export default ModalShell;
